/**
 * Send process to event loop
 * ```
 * To schedule a new macrotask - Use zero delayed setTimeout(f).
 * ```
 * @see https://javascript.info/event-loop
 * @param callback
 */
export function queueAsMacrotask(callback: Function) {
  setTimeout(callback);
}
